import MainCard from 'components/MainCard';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { MessageDto } from 'common/dto-types/message-dto';
import MessageForm from 'components/message-form';
import { getMessageById } from '../api';
import { Box, CircularProgress } from '@mui/material';
import { NotFoundErrorPage } from 'routes';

const MessageDetailsPage = () => {
    const { id } = useParams();
    const [message, setMessage] = useState<MessageDto | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        // If id exists and is not 'new', fetch the message
        if (id && id !== 'new') {
            setLoading(true);
            setNotFound(false);
            getMessageById(parseInt(id))
                .then((data) => {
                    if (data) {
                        setMessage(data);
                    } else {
                        // Data is null - message not found
                        setNotFound(true);
                    }
                })
                .catch(() => {
                    setNotFound(true);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [id]);

    // Show loading indicator
    if (loading) {
        return (
            <MainCard content={false} sx={{ width: '100%', marginX: 'auto' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400, p: 3 }}>
                    <CircularProgress />
                </Box>
            </MainCard>
        );
    }

    // Show 404 if message not found
    if (notFound) {
        return <NotFoundErrorPage />;
    }

    // Show form
    return (
        <MainCard content={false} sx={{ width: '100%', marginX: 'auto' }}>
            <MessageForm message={message} />
        </MainCard>
    );
};

export default MessageDetailsPage;
